import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'luma_cookies_accepted';

const CookieBanner: React.FC = () => {
    const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, '1');
        setVisible(false);
    };

    if (!visible) return null;

    // No outer `fixed` wrapper here — this renders as one card inside <NoticeBannerStack>,
    // which owns the shared fixed-bottom positioning so this can stack with other banners
    // (e.g. TermsUpdateBanner) instead of overlapping them.
    return (
        <div className="pointer-events-auto max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4 rounded-2xl border border-white/10 bg-zinc-950/95 backdrop-blur-xl px-5 py-4 shadow-2xl">
            <div className="flex-1 text-xs text-zinc-400 leading-relaxed">
                We use cookies for session authentication and optional analytics.
                By continuing you agree to our{' '}
                <Link to="/privacy" className="text-white underline underline-offset-2 hover:text-zinc-300">
                    Privacy Policy
                </Link>
                {' '}and{' '}
                <Link to="/terms" className="text-white underline underline-offset-2 hover:text-zinc-300">
                    Terms of Service
                </Link>.
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
                <button
                    onClick={accept}
                    className="px-4 py-2 rounded-full bg-white text-black text-xs font-bold hover:bg-zinc-200 transition-colors"
                >
                    Accept
                </button>
                <button
                    onClick={accept}
                    className="px-4 py-2 rounded-full border border-white/10 text-zinc-400 text-xs font-bold hover:text-white hover:border-white/30 transition-colors"
                >
                    Decline
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;
